<template>
  <q-dialog v-model="shown">
    <q-card style="width: 950px; max-width: 950px;">
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          {{ select ? 'Select' : '' }} Effective Type
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section horizontal>
        <q-card-section class="q-pa-none">
          <div
            style="max-height: 100%;"
            class="scrollable"
          >
            <q-list
              bordered
              separator
              style="min-width: 280px; max-width: 280px; max-height: 600px; overflow-y: auto;"
            >
              <q-item
                class="bg-grey-2 text-subtitle2"
                style="padding-top: 6px;"
                dense
              >
                Standard
              </q-item>

              <q-item
                clickable
                :active="internalValue === EFFECTIVE_TYPES.SALES"
                :class=" { 'bg-grey-4': internalValue === EFFECTIVE_TYPES.SALES } "
                @click="internalValue = EFFECTIVE_TYPES.SALES"
                @mouseenter="handleMouseEnter(EFFECTIVE_TYPES.SALES)"
              >
                <q-item-section>
                  <q-item-label lines="1">
                    Sales Basis
                  </q-item-label>
                  <q-item-label caption>
                    Net of items sold during report period
                  </q-item-label>
                </q-item-section>
              </q-item>

              <q-item
                clickable
                :active="internalValue === EFFECTIVE_TYPES.CASH_BASIS"
                :class=" { 'bg-grey-4': internalValue === EFFECTIVE_TYPES.CASH_BASIS } "
                @click="internalValue = EFFECTIVE_TYPES.CASH_BASIS"
                @mouseenter="handleMouseEnter(EFFECTIVE_TYPES.CASH_BASIS)"
              >
                <q-item-section>
                  <q-item-label lines="1">
                    Cash Basis
                  </q-item-label>
                  <q-item-label caption>
                    Net of items paid during report period
                  </q-item-label>
                </q-item-section>
              </q-item>

              <q-item
                clickable
                :active="internalValue === EFFECTIVE_TYPES.ACCRUAL"
                :class=" { 'bg-grey-4': internalValue === EFFECTIVE_TYPES.ACCRUAL } "
                @click="internalValue = EFFECTIVE_TYPES.ACCRUAL"
                @mouseenter="handleMouseEnter(EFFECTIVE_TYPES.ACCRUAL)"
              >
                <q-item-section>
                  <q-item-label lines="1">
                    Accrual
                  </q-item-label>
                  <q-item-label caption>
                    Net of items effective during report period (unchanged by sales and voids after reporting period)
                  </q-item-label>
                </q-item-section>
              </q-item>

              <q-item
                clickable
                :active="internalValue === EFFECTIVE_TYPES.ATTENDANCE"
                :class="{ 'bg-grey-4': internalValue === EFFECTIVE_TYPES.ATTENDANCE }"
                @click="internalValue = EFFECTIVE_TYPES.ATTENDANCE"
                @mouseenter="handleMouseEnter(EFFECTIVE_TYPES.ATTENDANCE)"
              >
                <q-item-section>
                  <q-item-label lines="1">
                    Attendance
                  </q-item-label>
                  <q-item-label caption>
                    Net of items effective during report period (changed by sales and voids after reporting period)
                  </q-item-label>
                </q-item-section>
              </q-item>

              <q-item
                class="bg-grey-2 text-subtitle2"
                style="padding-top: 6px;"
                dense
              >
                Accrual
              </q-item>

              <q-item
                clickable
                :active="internalValue === EFFECTIVE_TYPES.CURRENT_SALES"
                :class=" { 'bg-grey-4': internalValue === EFFECTIVE_TYPES.CURRENT_SALES } "
                @click="internalValue = EFFECTIVE_TYPES.CURRENT_SALES"
                @mouseenter="handleMouseEnter(EFFECTIVE_TYPES.CURRENT_SALES)"
              >
                <q-item-section>
                  <q-item-label lines="1">
                    Current Sales
                  </q-item-label>
                  <q-item-label caption>
                    Net of items sold during report period, effective in report period
                  </q-item-label>
                </q-item-section>
              </q-item>

              <q-item
                clickable
                :active="internalValue === EFFECTIVE_TYPES.MATURING_SALES"
                :class=" { 'bg-grey-4': internalValue === EFFECTIVE_TYPES.MATURING_SALES } "
                @click="internalValue = EFFECTIVE_TYPES.MATURING_SALES"
                @mouseenter="handleMouseEnter(EFFECTIVE_TYPES.MATURING_SALES)"
              >
                <q-item-section>
                  <q-item-label lines="1">
                    Maturing Sales
                  </q-item-label>
                  <q-item-label caption>
                    Net of items sold prior to report period, effective in report period
                  </q-item-label>
                </q-item-section>
              </q-item>

              <q-item
                clickable
                :active="internalValue === EFFECTIVE_TYPES.FUTURE_SALES"
                :class=" { 'bg-grey-4': internalValue === EFFECTIVE_TYPES.FUTURE_SALES } "
                @click="internalValue = EFFECTIVE_TYPES.FUTURE_SALES"
                @mouseenter="handleMouseEnter(EFFECTIVE_TYPES.FUTURE_SALES)"
              >
                <q-item-section>
                  <q-item-label lines="1">
                    Future Sales
                  </q-item-label>
                  <q-item-label caption>
                    Net of items sold during report period, effective after report period
                  </q-item-label>
                </q-item-section>
              </q-item>

              <q-item
                clickable
                :active="internalValue === EFFECTIVE_TYPES.PAST_SALES"
                :class=" { 'bg-grey-4': internalValue === EFFECTIVE_TYPES.PAST_SALES } "
                @click="internalValue = EFFECTIVE_TYPES.PAST_SALES"
                @mouseenter="handleMouseEnter(EFFECTIVE_TYPES.PAST_SALES)"
              >
                <q-item-section>
                  <q-item-label lines="1">
                    Past Sales
                  </q-item-label>
                  <q-item-label caption>
                    Net of items sold during report period, effective before report period
                  </q-item-label>
                </q-item-section>
              </q-item>

              <q-item
                clickable
                :active="internalValue === EFFECTIVE_TYPES.RETROACTIVE_SALES"
                :class=" { 'bg-grey-4': internalValue === EFFECTIVE_TYPES.RETROACTIVE_SALES } "
                @click="internalValue = EFFECTIVE_TYPES.RETROACTIVE_SALES"
                @mouseenter="handleMouseEnter(EFFECTIVE_TYPES.RETROACTIVE_SALES)"
              >
                <q-item-section>
                  <q-item-label lines="1">
                    Retroactive Sales
                  </q-item-label>
                  <q-item-label caption>
                    Net of items sold after report perdio, effective in report period
                  </q-item-label>
                </q-item-section>
              </q-item>

              <q-item
                class="bg-grey-2 text-subtitle2"
                style="padding-top: 6px;"
                dense
              >
                Accounts Receivable
              </q-item>

              <q-item
                clickable
                :active="internalValue === EFFECTIVE_TYPES.CURRENT_PAYMENTS"
                :class=" { 'bg-grey-4': internalValue === EFFECTIVE_TYPES.CURRENT_PAYMENTS } "
                @click="internalValue = EFFECTIVE_TYPES.CURRENT_PAYMENTS"
                @mouseenter="handleMouseEnter(EFFECTIVE_TYPES.CURRENT_PAYMENTS)"
              >
                <q-item-section>
                  <q-item-label lines="1">
                    Current Payments
                  </q-item-label>
                  <q-item-label caption>
                    Net of items paid during report period, effective in report period
                  </q-item-label>
                </q-item-section>
              </q-item>

              <q-item
                clickable
                :active="internalValue === EFFECTIVE_TYPES.UNPAID_PLACEMENTS"
                :class=" { 'bg-grey-4': internalValue === EFFECTIVE_TYPES.UNPAID_PLACEMENTS } "
                @click="internalValue = EFFECTIVE_TYPES.UNPAID_PLACEMENTS"
                @mouseenter="handleMouseEnter(EFFECTIVE_TYPES.UNPAID_PLACEMENTS)"
              >
                <q-item-section>
                  <q-item-label lines="1">
                    Unpaid Placements
                  </q-item-label>
                  <q-item-label caption>
                    Net of items sold during report period, not paid or paid past report period
                  </q-item-label>
                </q-item-section>
              </q-item>

              <q-item
                clickable
                :active="internalValue === EFFECTIVE_TYPES.PAID_PAST_PLACEMENTS"
                :class="{ 'bg-grey-4': internalValue === EFFECTIVE_TYPES.PAID_PAST_PLACEMENTS }"
                @click="internalValue = EFFECTIVE_TYPES.PAID_PAST_PLACEMENTS"
                @mouseenter="handleMouseEnter(EFFECTIVE_TYPES.PAID_PAST_PLACEMENTS)"
              >
                <q-item-section>
                  <q-item-label lines="1">
                    Pay Past Placements
                  </q-item-label>
                  <q-item-label caption>
                    Net of items paid during report period, sold before report period
                  </q-item-label>
                </q-item-section>
              </q-item>

              <q-item
                clickable
                :active="internalValue === EFFECTIVE_TYPES.ACCOUNTS_RECEIVABLE"
                :class="{ 'bg-grey-4': internalValue === EFFECTIVE_TYPES.ACCOUNTS_RECEIVABLE }"
                @click="internalValue = EFFECTIVE_TYPES.ACCOUNTS_RECEIVABLE"
                @mouseenter="handleMouseEnter(EFFECTIVE_TYPES.ACCOUNTS_RECEIVABLE)"
              >
                <q-item-section>
                  <q-item-label lines="1">
                    Accounts Receivable
                  </q-item-label>
                  <q-item-label caption>
                    Balance of items in Accounts Receivable at the end of the report period
                  </q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </div>
        </q-card-section>

        <q-card-section>
          <effective-type-detail :effective-type="previewValue" />
        </q-card-section>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import { EFFECTIVE_TYPES } from 'src/models/accounting/AccountSource'
import EffectiveTypeDetail from 'src/modules/admin/effective-type/EffectiveTypeDetail'

export default {
  name: 'EffectiveTypeDialog',
  components: { EffectiveTypeDetail },
  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    effectiveType: {
      type: String,
      required: false,
      default: EFFECTIVE_TYPES.SALES
    },
    mode: {
      type: String,
      required: false,
      default: 'select'
    },
    showVoids: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:model-value', 'select'],
  data () {
    return {
      shown: false,
      internalValue: this.effectiveType,
      previewValue: this.effectiveType
    }
  },
  computed: {
    select () {
      return this.mode === 'select'
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)

      if (this.shown) {
        this.previewValue = this.effectiveType
        this.internalValue = this.effectiveType
      } else {
        this.$emit('select', this.internalValue)
      }
    },
    internalValue () {
      if (this.mode === 'select') {
        this.$emit('select', this.internalValue)
        this.shown = false
      } else {
        this.previewValue = this.internalValue
      }
    }
  },
  created () {
    _.extend(this, {
      EFFECTIVE_TYPES
    })
  },
  methods: {
    handleMouseEnter (effectiveType) {
      if (!this.select) return

      this.previewValue = effectiveType
    }
  }
}

</script>
